import { Column as ColumnInter } from '@/vue-prop-types/DataTable/types'
import { deepClone } from '@/utils/tools'
/**
 * This class works a a simple type class ensuring that all columns follow a semi strict form.
 * It will also warn about bad column initialisation.
 * TODO: When we switch to typescript this class should/could be replaced by and interface or similar
 */
export default class Column implements ColumnInter {
  _col: ColumnInter
  get title() {
    return this._col.title
  }

  get key() {
    return this._col.key
  }

  get class() {
    return this._col.class
  }

  get colClass() {
    return this._col.colClass
  }

  get flexClass() {
    return this._col.flexClass
  }

  get order() {
    return this._col.order
  }

  get sort() {
    return this._col.sort
  }

  get type() {
    return this._col.type
  }

  get renderUsing() {
    return this._col.renderUsing
  }

  // Specifically extra keys for fuse.js to work with. To see more about how these work look at ProvideSearch.vue or
  // https://fusejs.io/
  get searchKeys() {
    return this._col.searchKeys ?? []
  }

  // Function that can convert a record value into the correct type. Used for comparison and search
  get convert() {
    return this._col.convert
  }

  get orderAble() {
    return this._col?.orderAble ?? true
  }

  get slot() {
    return this._col.slot
  }

  get ignoreClickForRowSelection() {
    return this._col.ignoreClickForRowSelection
  }

  constructor(col: ColumnInter) {
    this._col = deepClone(col) as ColumnInter
  }
}
